import * as React from "react";
import AbstractLookup, { LookupConfigInterface } from "./AbstractLookup";
import { LookupInterface } from "./LookupInterface";
import * as onClickOutside from "react-onclickoutside";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import Translator from "../../../Translation/Translator";
import Constants from "../../../Action/Constants";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";

class UnitLookup extends AbstractLookup implements LookupInterface {

  protected componentRef: any;
  protected config: LookupConfigInterface = {
    entities: Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]),
    type: Constants.LOOKUP_COMPONENT_UNIT_CREATE_START,
    payloadPrefix: "unit",
    entityTranslation: Translator.trans("title-unit"),
    disableEntityCreation: this.props.disableEntityCreation || false,
    floatingLabelText: this.props.floatingLabelText || Translator.trans("dropdown-searchforunit-label"),
    labelText: Translator.trans("dropdown-unit-label"),
    buttonLabel: this.props.buttonLabel || Translator.trans("button-add-unit"),
    dialogTitle: this.props.dialogTitle || Translator.trans("button-add-unit"),
    dialogType: this.props.dialogType || Constants.LOOKUP_COMPONENT_DIALOG_TYPE_SMALL,
    visibilityProperty: this.props.fullUnitName === true ? "displayName" : "unitNumber",
    dialogInputToComponentSyncProperty: "unitNumber",
    componentState: {
      unitNumber: ""
    },
    filter: this.props.filter || false,
    createPage: "/app/unit/create",
    linkedObjectUrl: "/app/unit/update/",
    noResultText: this.props.noResultText || this.trans("dropdown-unit-notfound")
  };

  constructor(public props) {
    super(props);
  }

  public syncDialogValue(value: string): any {
    this.config.componentState.unitNumber = value;
    this.setState({
      unitNumber: value
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public unitComparer = (a, b) => {
    return this.comparer(a.property.address.locality, b.property.address.locality) ||
      this.comparer(a.property.address.route, b.property.address.route) ||
        this.comparer(a.property.address.formattedAddress, b.property.address.formattedAddress) ||
          this.comparer(a.unitNumber, b.unitNumber);
  }

  public getList(): any[] {
    let list: UnitInterface[] = this.getEntities()
      .filter((unit: UnitInterface) => {
        return unit.displayName.toLowerCase().includes(String(this.state.searchText).toLowerCase());
      })
      .sort(this.unitComparer);

    return list.map((unit: UnitInterface, index: number) => {
      return (
        <ListItem
          key={index}
          onMouseDown={this.onSelect.bind(this, unit)}
        >
          <ListItemAvatar>
            <Avatar className="avatar">
              {unit.renderAvatar()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={unit.displayName}
          />
        </ListItem>
      );
    });
  }

  public getEntities(): UnitInterface[] {
    if (Array.isArray(this.props.entitiesToSearch)) {
      return this.props.entitiesToSearch;
    } else {
      return Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id])
        .filter(unit => !!unit)
        .filter(unit => {
          if(this.props.filterContractWithActiveContract){
            return !!unit?.getActiveContract()
          } else {
            return !!unit
          }
        })
        .filter((unit: UnitInterface) => {
          return unit.removed === false || (unit.removed === true && !!this.props.autoSelectId && unit.id === this.props.autoSelectId);
        });
    }
  }

  public getPayloadFromComponent(): any {
    return {};
  }
}

export default onClickOutside(UnitLookup);
